var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_calendar",
    "data-name": "vuesax/bold/calendar",
    transform: "translate(-492 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(492 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M13.711,2.31V.75a.75.75,0,0,0-1.5,0v1.5h-6.5V.75a.75.75,0,0,0-1.5,0V2.31A4.248,4.248,0,0,0,0,6.56a.5.5,0,0,0,.5.53h16.92a.5.5,0,0,0,.5-.53A4.248,4.248,0,0,0,13.711,2.31Z",
    transform: "translate(495.039 189.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_17",
    "data-name": "Exclusion 17",
    d: "M22122-7626.842h-8a4.98,4.98,0,0,1-3.814-1.375,5.139,5.139,0,0,1-1.189-3.623V-7638a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1v6.159a5.139,5.139,0,0,1-1.189,3.623A4.98,4.98,0,0,1,22122-7626.842Zm-4-4.828a.562.562,0,0,1,.293.075l.9.533a1.052,1.052,0,0,0,.5.168.366.366,0,0,0,.3-.131.8.8,0,0,0,.059-.671l-.211-.916a.658.658,0,0,1,.162-.544l.75-.75a.616.616,0,0,0,.234-.606.645.645,0,0,0-.557-.371l-.955-.161a.609.609,0,0,1-.424-.311l-.527-1.061c-.141-.273-.326-.423-.52-.423s-.385.154-.523.435l-.527,1.061a.7.7,0,0,1-.422.311l-.961.161a.631.631,0,0,0-.555.361.629.629,0,0,0,.238.616l.738.738a.645.645,0,0,1,.158.544l-.209.916a.8.8,0,0,0,.061.67.364.364,0,0,0,.3.132,1.039,1.039,0,0,0,.5-.168l.9-.533A.565.565,0,0,1,22118-7631.67Z",
    transform: "translate(-21614 7836.84)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.5584e4f4772f866b3f06d240abdcc781.svg";
export { ForwardRef as ReactComponent };